import { Group } from 'react-konva';
import RoofToolFacets from '../Facet/RoofToolFacets';
import RoofToolLines from '../Facet/RoofToolLines';

type Props = {
	roofSegments: RasterRoofSegment[];
	deletedRoofSegIDs: string[];
}

export default function TempEditEdgeGroup({ roofSegments, deletedRoofSegIDs }: Props) {
	const filteredSegments = roofSegments.filter(rs => !deletedRoofSegIDs.includes(rs.id));

	return (
		<Group name='temp-edit-edge'>
			{
				filteredSegments.map((rs) => {
					return (
						<RoofToolFacets
							key={`facet-${rs.id}`}
							segmentId={rs.id}
							coordinates={rs.simplifiedHullCoords}
							label={rs.label} />
					);
				})
			}

			{
				filteredSegments.map((rs) => {
					return (
						<RoofToolLines
							key={`edge-${rs.id}`}
							segmentId={rs.id}
							coordinates={rs.simplifiedHullCoords}
							edges={rs.edges!}
						/>
					);
				})
			}
		</Group>
	);

}